<template>
  <div class="signature-filter-section">
    <div class="d-flex ga-3 justify-start">
      <SingleSelect
        :options="sortOptions"
        prefix="Sort by: "
        :model-value="selectedSort"
        @update:model-value="$emit('update:selectedSort', $event)"
        @change="onSortSelectChange"
      />
      <SingleSelect
        :options="seriesOptions"
        prefix="Series: "
        :model-value="selectedSeries"
        @update:model-value="$emit('update:selectedSeries', $event)"
        @change="onSeriesSelectChange"
      />
      <LocaleSelector
        v-model="selectedLocale"
        @update:modelValue="handleLocaleChange"
        :is-singapore-disabled="true"
      />
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, computed } from "vue";

import SingleSelect from "@/components/common/SingleSelect.vue";
import LocaleSelector from "@/components/common/LocaleSelector.vue";

const props = defineProps({
  selectedSort: {
    type: String,
    default: "newest",
  },
  selectedSeries: {
    type: String,
    default: "all",
  },
  selectedLocale: {
    type: String,
    default: "US",
  },
});

const selectedLocale = computed(() => props.selectedLocale);

const sortOptions = [
  { value: "newest", text: "<b><strong>Newest</strong></b>" },
  { value: "oldest", text: "<b><strong>Oldest</strong></b>" },
  { value: "a-z", text: "<b><strong>A-Z</strong></b>" },
  { value: "z-a", text: "<b><strong>Z-A</strong></b>" },
];

const seriesOptions = [
  { value: "all", text: "<b><strong>All Type</strong></b>" },
  { value: "TrendX", text: "<b><strong>TrendX</strong></b>" },
  {
    value: "Curriculum Connect",
    text: "<b><strong>Curriculum Connect</strong></b>",
  },
  { value: "CTE", text: "<b><strong>CTE</strong></b>" },
];

const emit = defineEmits([
  "update:selectedSort",
  "update:selectedSeries",
  "update:selectedLocale",
]);

const onSortSelectChange = (payload) => {
  if (!payload || !payload.value) return;
  emit("update:selectedSort", payload.value);
};

const onSeriesSelectChange = (payload) => {
  if (!payload || !payload.value) return;
  emit("update:selectedSeries", payload.value);
};

const handleLocaleChange = (payload) => {
  if (!payload) return;
  emit("update:selectedLocale", payload);
};
</script>

<style scoped>
@media (max-width: 480px) {
  .signature-filter-section {
    display: none;
  }
}
</style>
